export const styles = {
  root: {
    fontFamily: 'text',
    fontWeight: 'text',
  },
  a: {
    variant: 'links.text'
  },
};
